import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const ReportGraphVerticalBar = ({ title, data, dataDr, fontFamily }) => {

	const hasData = dataDr && dataDr.length > 0;


	const categories = [];


	const values = [];

	if (hasData) {
		for (let i = 0; i < Math.min(16, dataDr.length); i++) {
			const result = dataDr[i];
			const Dr_nome = result.dr_nome;
			const quantidade_planos_aula = result.quantidade_planos_aula;


			categories.push(Dr_nome);


			values.push(quantidade_planos_aula);
		}
	}

	const mockData = {
		categories: categories,
		series: [
			{
				name: 'Quantidade de Planos de Aula',
				data: values,
			},
		],
	};

	const options = {
		chart: {
			type: 'column',
		},
		title: {
			text: title,
			align: 'center',
			style: {
				fontFamily: fontFamily, // Use a prop "fontFamily" aqui
			},
		},
		xAxis: {
			categories: mockData.categories,
			gridLineWidth: 0,
			labels: {
				style: {
					fontFamily: fontFamily, // Use a prop "fontFamily" aqui
				},
			},
		},
		yAxis: {
			title: {
				text: 'Valores',
				style: {
					fontFamily: fontFamily // Use a prop "fontFamily" aqui
				},
			},
			gridLineWidth: 0,
			labels: {
				style: {
					fontFamily: fontFamily, // Use a prop "fontFamily" aqui
				},
			},
		},
		plotOptions: {
			column: {
				stacking: 'normal',
			},
		},
		series: mockData.series,
	};
	return (
		<div style={{ height: '400px' }}>
			<HighchartsReact highcharts={Highcharts} options={options} />
		</div>
	);
};

export default ReportGraphVerticalBar;